import React from "react";

// Graphiques légers en SVG inline (aucune dépendance externe) — voir la note
// "chart library decision" : recharts alourdit le bundle et le build sur cette
// machine ~5 Go, donc on reste sur du SVG fait main, responsive via viewBox.

// Courbe / aire des auditeurs dans le temps.
export function AreaChart({ data = [], labels = [], height = 160, color = "#7c3aed" }) {
  const values = data.map((v) => Number(v) || 0);
  const n = values.length;
  if (n === 0) return null;
  const w = 600;
  const h = height;
  const pad = 8;
  const max = Math.max(1, ...values);
  const stepX = n > 1 ? (w - pad * 2) / (n - 1) : 0;
  const y = (v) => h - pad - (v / max) * (h - pad * 2);
  const x = (i) => pad + i * stepX;
  const pts = values.map((v, i) => `${x(i)},${y(v)}`).join(" ");
  const area = `${pad},${h - pad} ${pts} ${x(n - 1)},${h - pad}`;
  const gid = "areaGrad" + Math.round(color.charCodeAt(1) || 0);

  // Étiquettes clairsemées (max ~6) pour ne pas surcharger.
  const tickEvery = Math.max(1, Math.ceil(n / 6));

  return (
    <div className="w-full">
      <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" className="w-full" style={{ height }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.28" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>
        <polygon points={area} fill={`url(#${gid})`} />
        <polyline points={pts} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        {n <= 40 &&
          values.map((v, i) => <circle key={i} cx={x(i)} cy={y(v)} r="1.6" fill={color} />)}
      </svg>
      {labels.length > 0 && (
        <div className="flex justify-between mt-1 text-[10px] text-gray-400">
          {labels.map((lb, i) =>
            i % tickEvery === 0 || i === labels.length - 1 ? (
              <span key={i} className="truncate">{lb}</span>
            ) : null
          )}
        </div>
      )}
    </div>
  );
}

// Liste à barres horizontales (par pays, best/worst…).
export function BarList({ items = [], color = "#3b82f6", unit }) {
  const max = Math.max(1, ...items.map((it) => Number(it.value) || 0));
  return (
    <ul className="space-y-2.5">
      {items.map((it, i) => {
        const v = Number(it.value) || 0;
        const pct = Math.max(2, (v / max) * 100);
        return (
          <li key={i}>
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span className="truncate">{it.label}</span>
              <span className="font-medium text-gray-900 ms-2 whitespace-nowrap">
                {v}{unit ? ` ${unit}` : ""}
              </span>
            </div>
            <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${pct}%`, background: color }} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
